export default __webpack_public_path__ + "static/media/process.0ed6df8b.jpg";